import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-twenty-seven',
  templateUrl: './home-twenty-seven.component.html',
  styleUrls: ['./home-twenty-seven.component.scss']
})
export class HomeTwentySevenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
